// Mock data for TWINS LAWN & LANDSCAPE LLC website

export const companyInfo = {
  name: "TWINS LAWN & LANDSCAPE LLC",
  tagline: "Professional Lawn Care & Landscape Solutions You Can Trust",
  phone: "785-817-6900",
  email: "Twinslandscape@outlook.com",
  location: "Topeka, Kansas",
  instagram: "@TWINSLAWNANDLANDSCAPE",
  instagramUrl: "https://www.instagram.com/TWINSLAWNANDLANDSCAPE",
  facebookUrl: "https://www.facebook.com/twinslandscape"
};

export const services = [
  { id: 1, name: "Professional Finish Mowing", icon: "scissors" },
  { id: 2, name: "Complete Landscape Maintenance", icon: "trees" },
  { id: 3, name: "Spring & Fall Clean Up", icon: "leaf" },
  { id: 4, name: "Lawn Overseeding & Renovation", icon: "sprout" },
  { id: 5, name: "Irrigation Repair & Sprinkler Installation", icon: "droplets" },
  { id: 6, name: "Tree Pruning", icon: "tree-deciduous" },
  { id: 7, name: "Mulching", icon: "layers" },
  { id: 8, name: "Grading Solutions", icon: "move-diagonal" },
  { id: 9, name: "Fence Repair & Installation", icon: "fence" },
  { id: 10, name: "Hardscapes", icon: "brick-wall" },
  { id: 11, name: "Retaining Walls", icon: "landmark" },
  { id: 12, name: "Paver Patios & Walkways", icon: "footprints" },
  { id: 13, name: "Fire Pits", icon: "flame" },
  { id: 14, name: "Sodding", icon: "grip" },
  { id: 15, name: "Landscaping", icon: "flower-2" },
  { id: 16, name: "Snow Removal", icon: "snowflake" },
  { id: 17, name: "Concrete Sidewalks", icon: "move-horizontal" },
  { id: 18, name: "And More", icon: "plus-circle" }
];

export const reviews = [
  {
    id: 1,
    name: "Jenn Hawks",
    text: "Twins Lawn And Landscape has been amazing. We've had them do multiple jobs for us, and they maintain our sprinklers and lawn. They pay attention to detail and always edge our yard perfectly. They do everything from snow removal, lawns, landscaping, tree removal, irrigation, and more. We are lucky to have found such a great company. Thank you for always keeping our yard looking great.",
    rating: 5,
    recommends: true
  },
  {
    id: 2,
    name: "Brenda Holle Harwood",
    text: "Highly recommend. We had them install a French drain, limestone retaining wall and landscaping. Their work was excellent quality. They are reliable, flexible when we had changes, and very hard working. We are very happy with their work!",
    rating: 5,
    recommends: true
  },
  {
    id: 3,
    name: "Mabel Snow Bird",
    text: "Very nice and helpful. And on time.",
    rating: 5,
    recommends: true
  }
];

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/04dqnidl_PHOTO-2026-01-26-12-34-00.jpeg",
  about: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/vp8xbud7_PHOTO-2026-01-26-12-34-00.jpeg",
  hardscape: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/4gto9qil_PHOTO-2026-01-26-12-34-00.jpeg",
  lawnMower: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/vjutchm0_PHOTO-2026-01-26-12-34-00.jpeg",
  garden: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/gonv9igt_PHOTO-2026-01-26-12-34-00.jpeg"
};

export const navLinks = [
  { id: 1, label: "Home", href: "#home" },
  { id: 2, label: "About", href: "#about" },
  { id: 3, label: "Services", href: "#services" },
  { id: 4, label: "Gallery", href: "#gallery" },
  { id: 5, label: "Reviews", href: "#reviews" },
  { id: 6, label: "Contact", href: "#contact" }
];
